<template>
    <div class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">Suche</span>
        </div>
        <input id="globSearch" v-model="search" @keydown.esc="search = ''"
               type="text" class="form-control" :placeholder="placeholder">
        <div v-if="search.length" @click="search = ''" class="input-group-append">
            <label for="globSearch" class="input-group-text btn btn-info text-white">Schließen</label>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'SearchInput',
        props: {
	        placeholder: String
        },
        mounted () {
			console.log(this);
        }
	};
</script>

<style scoped>

</style>